export const submitButtonProps = {
	className: "grow",
	accentColor: "primary",
	variant: "surface",
} as const

export const draftCancelButtonProps = {
	className: "grow",
	accentColor: "warning",
	variant: "surface",
} as const
